import { Component } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import ScrollMenu from '../../../SearchbarComponents/Menu';
import withComponentName from '../../../../decorators/withComponentName';

import departmentsImg from '../../../../assets/academia/group-81.svg';
import departmentTabletImg from '../../../../assets/academia/departments-tablet.svg';
import { academicTabs } from '../../../../data/landinaPages/academiaLanding';

import Styles from '../styles.module.scss';
import ButtonComponent from '../../../Buttons/ButtonComponent';
import windowWidthDecorator from '../../../../decorators/windowWidthDecorator';

const cx = classNames.bind(Styles);

export const Menu = (list, selected) => list.map((el) => {
  const { tabTitle, eventKey } = el;

  return <MenuItem text={tabTitle} key={eventKey} selected={selected} />;
});

const MenuItem = ({ text, selected }) => (
  <div className={`${Styles.tab_item} ${selected ? `${Styles.active}` : ''}`}>{text}</div>
);

const Arrow = ({ wrapperClass, className, icon }) => (
  <div className={wrapperClass}>
    <FontAwesomeIcon icon={icon} className={className} />
  </div>
);

const ArrowLeft = (classList = {}) => (
  Arrow({
    wrapperClass: `${Styles.arrow} ${Styles.arrow_prev}`,
    className: cx(classList),
    icon: faAngleLeft,
  })
);
const ArrowRight = (classList = {}) => (
  Arrow({
    wrapperClass: `${Styles.arrow} ${Styles.arrow_next}`,
    className: cx(classList),
    icon: faAngleRight,
  })
);

class AcademicDepartmentsSection extends Component {
  constructor(props) {
    super(props);
    this.menuItems = Menu(academicTabs, 'science');
    this.state = {
      activeTab: 'science',
    };
    autoBind(this);
  }

  toggleTab(activeTab) {
    this.setState({
      activeTab,
    });
  }

  render() {
    const { activeTab } = this.state;
    const { windowWidth } = this.props;

    const menu = this.menuItems;

    const arrowLeft = ArrowLeft();
    const arrowRight = ArrowRight();

    return (
      <section className={cx('academic-departments-section', 'section-wrapper')}>
        <div className={Styles['section-head']}>
          <h2 className={Styles['section-title']}>Not just finance and economics</h2>
          <p className={`${cx('description')} text-center`}>
            Many academic departments and disciplines find value in CityFALCON
          </p>
        </div>
        <div
          className={Styles['tabs-container']}
        >
          <div className={Styles['tabs-wrapper']}>
            <ScrollMenu
              alignCenter={false}
              data={menu}
              arrowLeft={arrowLeft}
              translate={1}
              arrowRight={arrowRight}
              selected={activeTab}
              onSelect={this.toggleTab}
              wrapperClass={Styles['tabs-menu-wrapper']}
              innerWrapperClass={Styles['tabs-inner-menu']}
              hideArrows
              hideSingleArrow
            />
          </div>
        </div>
        <div className={Styles['tab-content-wrapper']}>
          <div className={Styles['tab-content-inner']}>
            {academicTabs.map(({ eventKey, listItems }) => (
              <TabContent
                eventKey={eventKey}
                listItems={listItems}
                activeTab={activeTab}
                key={eventKey}
              />
            ))}
            <div className={Styles['tabs-contact-us']}>
              <ButtonComponent
                withoutReload
                value="Get Started"
                path="/news/onboarding/watchlist"
                green
              />
            </div>
          </div>
          <div className={Styles['academia-departments-image']}>
            {windowWidth <= 1024 ? (
              <img src={departmentTabletImg} alt="cityfalcon departments" />
            ) : (
              <img src={departmentsImg} alt="cityfalcon departments" />
            )}
          </div>
        </div>
      </section>
    );
  }
}

const TabContent = ({ listItems, activeTab, eventKey }) => (
  <>
    {eventKey === activeTab && (
      <ul className={Styles['tab-content']}>
        {listItems.map((listItem) => (
          <li key={listItem}>
            <FontAwesomeIcon icon={faCheck} />
            <p className={Styles.description}>{listItem}</p>
          </li>
        ))}
      </ul>
    )}
  </>
);

export default withComponentName(windowWidthDecorator(AcademicDepartmentsSection));
